import React from 'react';
import BoxSquared from '../BoxSquared/BoxSquared';
import { CircularProgress, Box, Grid } from '@material-ui/core';

const TextBody = ({
  classes = null,
  text = null,
  title = null,
  textImage = null,
  marginTop = 0,
  noBrackets = false,
}) => {
  return (
    <>
      <Grid container justify="center" direction="row" wrap="wrap" spacing={1}>
        <Grid item xs={12} md={12} className={classes.bottom}>
          {text ? (
            <BoxSquared
              title={title}
              titleCenter
              text={text}
              variantText="body1"
              colorTitle="orange"
              colorText="grey"
              backgroundColor="white"
              heightFixed={false}
              widthFixed={false}
              textAlign="left"
              padding="20px"
              justifycontent="left"
              disabledPointer={true}
              textImage={textImage}
              marginTop={marginTop}
              noBrackets={noBrackets}
            />
          ) : (
            <Box
              style={{ height: '300px' }}
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              alignItems="center"
            >
              <CircularProgress size={200} />
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default TextBody;
